import lodash from 'lodash';

import {EASINGS} from '../../ecs/easingHelper';
import letterFadePositionInRightGif from '../../../assets/images/transitions/letterFadePositionInRight.gif';

/**
 * The name that signals this preset.
 * @const {string}
 */
export const PRESET_LETTER_FADE_POSITION_OUT_RIGHT = 'letterFadePositionOutRight';

/**
 * The preset details.
 *
 * @type {{
 *   name: string,
 *   flow: string,
 *   details: Object.<string, {
 *     easing: string,
 *     parse: boolean,
 *     values: *|Array.<*>,
 *     time: {start: (string|number), end: (string|number)}
 *   }>,
 *   template: {}
 * }}
 */
export const letterFadePositionOutRightPresetDetails = {
  // The name of the preset.
  name: PRESET_LETTER_FADE_POSITION_OUT_RIGHT,

  // A human friendly name for the preset.
  humanName: 'Letter - Fade & Position Out From Right',

  // A preview of the transition.
  gif: letterFadePositionInRightGif,

  // The element names that this preset can be used for or true for all elements.
  elements: ['text'],

  // The preset direction: in, out, middle. This is used in the UI logic.
  flow: 'out',

  // Each property that will change during the transition.
  details: {
    'letter.opacity': {
      time: {
        end: 'end.-742',
        start: 'end.-1000'
      },
      easing: EASINGS.easeInExpo,
      values: [
        1,
        0
      ],
      stagger: -30,
      staggerDuration: false,
      immediateRender: false
    },
    'letter.translateX': {
      time: {
        end: 'end.-742',
        start: 'end.-1000'
      },
      easing: EASINGS.easeInExpo,
      values: [
        0,
        150
      ],
      stagger: -30,
      immediateRender: false
    },
  },

  // How this preset can be used in the source (including optional parameters).
  // This will be turned into a JSON string, so no functions can be used.
  template: {
    preset: PRESET_LETTER_FADE_POSITION_OUT_RIGHT,
    options: {},
  },
};

letterFadePositionOutRightPresetDetails.template.options = lodash.cloneDeep(letterFadePositionOutRightPresetDetails.details);

// This defines the key in the presets object.
export const presetName = PRESET_LETTER_FADE_POSITION_OUT_RIGHT;

// This defines the value of the presets object.
export default letterFadePositionOutRightPresetDetails;
